import { Observable, of } from 'rxjs';
import { ComponentPermissionService, PermissionFunction } from '../component-permission.service';

export function hasSpecificRole(service: ComponentPermissionService): PermissionFunction {
  return {
    name: 'Has Specific Role',
    description: 'Check if user has a specific role (role must be provided in context.requiredRole)',
    requiresContext: true,
    execute: (context?: any) => {
      
      // If no required role provided, deny access
      if (!context?.requiredRole) {
        return of(false);
      }

      // Get current user
      const currentUser = service.authService.getCurrentUser();
      if (!currentUser) {
        return of(false);
      }

      // Check if user has the required role
      const requiredRole = context.requiredRole;
      if (currentUser.roles && currentUser.roles.includes(requiredRole)) {
        return of(true);
      }

      return of(false);
    }
  };
} 